export enum PostingDate {
    exportedDate = 'Exported Date',
    newestExpenseItemDate = 'Newest Expense Item Date',
    oldestExpenseItemDate = 'Oldest Expense Item Date'
}


